export default {
    common: {
        save: 'Save',
        cancel: 'Cancel'
    },
    currency: {
        symbol: 'LAK'
    }
}
